(function() {
  'use strict';

  function initLpReviewsSlider(section) {
    if (!section?.dataset.sectionId) return;

    const sectionId = section.dataset.sectionId;
    const swiperEl = section.querySelector(`.lp-reviews-slider-${sectionId}`);
    if (!swiperEl || typeof Swiper === 'undefined') return;

    // Check if already initialized
    if (swiperEl.swiper) return;

    const prevButton = section.querySelector(`.lp-reviews-slider__nav-prev-${sectionId}`);
    const nextButton = section.querySelector(`.lp-reviews-slider__nav-next-${sectionId}`);

    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton
      }
    });
  }

  // Initialize sections
  const initSections = () => {
    document.querySelectorAll('.lp-reviews-slider[data-section-id]').forEach(initLpReviewsSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }

  // Re-initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.detail.querySelector('.lp-reviews-slider');
    if (section) {
      // Destroy existing Swiper if it exists
      const swiperEl = section.querySelector('.lp-reviews-slider__swiper');
      if (swiperEl?.swiper) {
        swiperEl.swiper.destroy(true, true);
      }
      initLpReviewsSlider(section);
    }
  });
})();

